/**
 * COVERFECT — Size Selector V11
 * ==============================
 * Based on V10: manual variant update + compare_at_price fix.
 * V11 change: fix currency bug — variant change now respects Shopify Markets
 *   active currency (VND, EUR, etc.) instead of hardcoding USD/$. Uses
 *   Intl.NumberFormat with Shopify.currency.active for proper formatting.
 */

(function () {
  'use strict';

  // Map each variant value → which tab it belongs to
  const VARIANT_MAP = {
    '28″x28″ (1pc)':              { part: 'armrest', label: 'Standard Arm', desc: 'Arm width under 28"' },
    '35″x35″ (1pc)':              { part: 'armrest', label: 'Wide Arm', desc: 'Arm width 28-35"' },
    'Backrest 35"x35"':            { part: 'backrest', label: 'Standard Back', desc: 'Back under 35" · Buy 2-3 for full sofa back' },
    'Backrest 43"x43"':            { part: 'backrest', label: 'Deep / Wide Back', desc: 'Back 36-43" · For oversized cushions' },
    '35″x47″ (1pc)':              { part: 'seat', label: 'Compact', desc: 'Small loveseat (40-47")', depth: 'standard' },
    '35″x63″ (1pc)':              { part: 'seat', label: '2-Seat', desc: 'Loveseat (48-63")', depth: 'standard' },
    '35″x71″ (1pc)':              { part: 'seat', label: '2-3 Seat', desc: 'Large loveseat / small 3-seat (64-71")', depth: 'standard' },
    '35″x83″ (1pc)':              { part: 'seat', label: '3-Seat', desc: 'Standard 3-seater (72-83")', depth: 'standard', popular: true },
    '35″x95″ (1pc)':              { part: 'seat', label: '4-Seat', desc: 'Large sofa (84-95")', depth: 'standard' },
    '43"x43" (1pc)':               { part: 'seat', label: '1-Seat Deep', desc: 'Deep single seat (up to 43")', depth: 'deep' },
    '43"x63" (1pc)':               { part: 'seat', label: '2-Seat Deep', desc: 'Deep loveseat (48-63")', depth: 'deep' },
    '43"x71" (1pc)':               { part: 'seat', label: '2-3 Seat Deep', desc: 'Deep large loveseat (64-71")', depth: 'deep' },
    '43"x83" (1pc)':               { part: 'seat', label: '3-Seat Deep', desc: 'Deep 3-seater (72-83")', depth: 'deep' },
    '43"x95" (1pc)':               { part: 'seat', label: '4-Seat Deep', desc: 'Deep 4-seater (84-95")', depth: 'deep' },
    'Double Seat Set (5pcs)':      { part: 'bundle', label: 'Loveseat Set', desc: 'Seat 1pc + Backrest 2pcs + Handrail 2pcs' },
    '3 Seat + 2 Handrails (3pcs)': { part: 'bundle', label: '3-Seat + Arms', desc: 'Seat 1pc + Handrail 2pcs' },
    'Three Seat Set (6pcs)':       { part: 'bundle', label: '3-Seat Full Set', desc: 'Seat 1pc + Backrest 3pcs + Handrail 2pcs', popular: true },
    'Four Seat Set (7pcs)':        { part: 'bundle', label: '4-Seat Full Set', desc: 'Seat 1pc + Backrest 4pcs + Handrail 2pcs' },
    '3-Seat L-Shaped Set (7pcs)':  { part: 'bundle', label: 'L-Shape 3-Seat', desc: 'Seat 1pc + Chaise 1pc + Backrest 3pcs + Handrail 2pcs' },
    '4-Seat L-Shaped Set (8pcs)':  { part: 'bundle', label: 'L-Shape 4-Seat', desc: 'Seat 1pc + Chaise 1pc + Backrest 4pcs + Handrail 2pcs' },
    'Pillow Cover 18″x18″':       { part: 'hidden' },
  };

  const TAB_CONFIG = {
    armrest:  { label: 'Armrest',       icon: '<svg width="40" height="32" viewBox="0 0 40 32" fill="none"><rect x="8" y="14" width="24" height="12" rx="2" stroke="#ccc" stroke-width="1.2" fill="none"/><rect x="8" y="6" width="24" height="10" rx="2" stroke="#ccc" stroke-width="1.2" fill="none"/><rect x="2" y="8" width="7" height="18" rx="2" fill="currentColor" opacity="0.85"/><rect x="31" y="8" width="7" height="18" rx="2" fill="currentColor" opacity="0.85"/></svg>' },
    backrest: { label: 'Backrest',      icon: '<svg width="40" height="32" viewBox="0 0 40 32" fill="none"><rect x="8" y="14" width="24" height="12" rx="2" stroke="#ccc" stroke-width="1.2" fill="none"/><rect x="8" y="5" width="24" height="10" rx="2" fill="currentColor" opacity="0.85"/><rect x="2" y="8" width="7" height="18" rx="2" stroke="#ccc" stroke-width="1.2" fill="none"/><rect x="31" y="8" width="7" height="18" rx="2" stroke="#ccc" stroke-width="1.2" fill="none"/></svg>' },
    seat:     { label: 'Seat & Chaise', icon: '<svg width="40" height="32" viewBox="0 0 40 32" fill="none"><rect x="8" y="14" width="24" height="12" rx="2" fill="currentColor" opacity="0.85"/><rect x="8" y="5" width="24" height="10" rx="2" stroke="#ccc" stroke-width="1.2" fill="none"/><rect x="2" y="8" width="7" height="18" rx="2" stroke="#ccc" stroke-width="1.2" fill="none"/><rect x="31" y="8" width="7" height="18" rx="2" stroke="#ccc" stroke-width="1.2" fill="none"/></svg>' },
    bundle:   { label: 'Full Sets', badge: 'SAVE MORE', icon: '<svg width="40" height="32" viewBox="0 0 40 32" fill="none"><rect x="8" y="14" width="24" height="12" rx="2" fill="currentColor" opacity="0.85"/><rect x="8" y="5" width="24" height="10" rx="2" fill="currentColor" opacity="0.85"/><rect x="2" y="8" width="7" height="18" rx="2" fill="currentColor" opacity="0.85"/><rect x="31" y="8" width="7" height="18" rx="2" fill="currentColor" opacity="0.85"/><circle cx="20" cy="17" r="5" fill="white"/><path d="M17.5 17l1.8 1.8 3.2-3.6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' },
  };

  // Normalize all quote-like chars to ASCII " for robust matching
  // (Shopify uses ″ U+2033 for some variants, " U+0022 for others;
  //  pasting into theme editor can mangle these)
  function norm(s) {
    return s.replace(/[\u2033\u2032\u201C\u201D\u201E\u201F\u2018\u2019\u201A\u201B\u00AB\u00BB\u2039\u203A\u2033\u201C\u201D\u2018\u2019]/g, '"');
  }
  const NORM_MAP = {};
  for (const [key, val] of Object.entries(VARIANT_MAP)) {
    NORM_MAP[norm(key)] = val;
  }
  function lookupVariant(value) {
    return VARIANT_MAP[value] || NORM_MAP[norm(value)] || null;
  }

  const MAIN_PARTS = ['armrest', 'backrest', 'seat', 'bundle'];
  let activeTab = null;
  let activeDepth = 'standard';
  let savedScrollY = null;

  // Inline style helpers — immune to Alpine.js class stripping & Tailwind specificity
  function cfHide(el) {
    el.style.setProperty('display', 'none', 'important');
    el.style.setProperty('visibility', 'hidden', 'important');
    el.style.setProperty('position', 'absolute', 'important');
    el.style.setProperty('width', '0', 'important');
    el.style.setProperty('height', '0', 'important');
    el.style.setProperty('overflow', 'hidden', 'important');
    el.style.setProperty('margin', '0', 'important');
    el.style.setProperty('padding', '0', 'important');
  }
  function cfShow(el, isLabel) {
    ['display','visibility','position','width','height','overflow','margin','padding'].forEach(function(p) { el.style.removeProperty(p); });
    // For labels, force flex column layout (override Tailwind's "flex items-center" row layout)
    if (isLabel) {
      el.style.setProperty('display', 'flex', 'important');
      el.style.setProperty('flex-direction', 'column', 'important');
      el.style.setProperty('align-items', 'flex-start', 'important');
    }
  }

  // ── V11: Currency-aware price formatter ─────────────────────────────
  // Uses Intl.NumberFormat with a locale matched to the active currency
  // so separators and symbol position match the theme's Liquid output.
  // Cached after first call for performance.
  var _cachedFmt = null;
  var CURRENCY_LOCALE = {
    VND:'vi',JPY:'ja',KRW:'ko',EUR:'de',GBP:'en-GB',CAD:'en-CA',
    AUD:'en-AU',INR:'en-IN',BRL:'pt-BR',MXN:'es-MX',THB:'th',
    TWD:'zh-TW',SGD:'en-SG',MYR:'ms-MY',PHP:'en-PH',IDR:'id',
    PLN:'pl',SEK:'sv',NOK:'nb',DKK:'da',CZK:'cs',HUF:'hu',
    ILS:'he',NZD:'en-NZ',CHF:'de-CH',ZAR:'en-ZA',AED:'ar-AE',
    SAR:'ar-SA',RUB:'ru',UAH:'uk',TRY:'tr',RON:'ro',BGN:'bg',
    HRK:'hr',CNY:'zh-CN',HKD:'zh-HK',
  };
  var ZERO_DEC = ['JPY','KRW','VND','CLP','ISK','UGX','BIF','DJF','GNF','KMF','MGA','PYG','RWF','XOF','XPF'];
  function cfFormatPrice(amount) {
    if (!_cachedFmt) {
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      var locale = CURRENCY_LOCALE[currency] || navigator.language || 'en';
      var dec = ZERO_DEC.indexOf(currency) !== -1 ? 0 : 2;
      try {
        var intl = new Intl.NumberFormat(locale, {
          style: 'currency', currency: currency,
          minimumFractionDigits: dec, maximumFractionDigits: dec,
        });
        _cachedFmt = function(n) { return intl.format(n); };
      } catch (e) {
        _cachedFmt = function(n) { return currency + ' ' + n; };
      }
    }
    return _cachedFmt(amount);
  }

  var styles = document.createElement('style');
  styles.textContent = [
    '/* ========== TABS ========== */',
    '.cf-part-tabs { display:grid; grid-template-columns:repeat(4,1fr); gap:8px; margin-bottom:12px; width:100%!important; flex:0 0 100%!important; }',
    '.cf-part-tab { padding:8px 4px; border:1.5px solid #e0dbd4; border-radius:8px; background:#fff; cursor:pointer; text-align:center; transition:all .2s; display:flex; flex-direction:column; align-items:center; justify-content:center; gap:4px; }',
    '.cf-part-tab:hover { border-color:#8b6914; background:#fffdf7; }',
    '.cf-part-tab.active { border-color:#8b6914; background:#f9f5ec; box-shadow:0 0 0 1px #8b6914; }',
    '.cf-part-tab .cf-tab-icon { color:#bbb; line-height:0; }',
    '.cf-part-tab .cf-tab-icon svg { width:40px; height:32px; }',
    '.cf-part-tab.active .cf-tab-icon { color:#8b6914; }',
    '.cf-part-tab .cf-tab-label { font-size:14px; font-weight:600; color:#777; }',
    '.cf-part-tab.active .cf-tab-label { color:#8b6914; }',
    '.cf-tab-badge { font-size:8px; font-weight:700; color:#fff; background:#c44a2f; padding:1px 5px; border-radius:3px; letter-spacing:.3px; }',

    '/* ========== DEPTH TOGGLE ========== */',
    '.cf-depth-toggle { display:inline-flex; gap:0; margin-bottom:10px; border:1px solid #e0dbd4; border-radius:8px; overflow:hidden; width:fit-content!important; max-width:fit-content!important; }',
    '.cf-depth-btn { padding:6px 14px; font-size:13px; font-weight:500; cursor:pointer; background:#fff; color:#888; border:none; border-right:1px solid #e0dbd4; transition:all .15s; }',
    '.cf-depth-btn:last-child { border-right:none; }',
    '.cf-depth-btn:hover { background:#f8f6f3; }',
    '.cf-depth-btn.active { background:#8b6914; color:#fff; }',

    '/* ========== SIZE BUTTONS ========== */',
    'fieldset[data-option-name="size"][data-cf-enhanced] { display:flex!important; flex-wrap:wrap!important; gap:8px!important; column-gap:8px!important; row-gap:8px!important; align-items:start!important; padding-top:2px!important; }',
    'fieldset[data-option-name="size"][data-cf-enhanced] > legend { flex:0 0 100%!important; width:100%!important; }',
    'fieldset[data-option-name="size"][data-cf-enhanced] label.cf-label-enhanced { position:relative!important; justify-content:center!important; padding:10px 12px!important; min-height:56px!important; min-width:0!important; max-width:220px!important; flex:1 1 calc(33.333% - 6px)!important; border:1.5px solid #e0dbd4!important; border-radius:8px!important; background:#fff!important; cursor:pointer!important; transition:border-color .15s,background .15s!important; box-sizing:border-box!important; font-size:13px!important; font-weight:600!important; color:#333!important; line-height:1.3!important; }',
    'fieldset[data-option-name="size"][data-cf-enhanced] label.cf-label-enhanced:hover { border-color:#8b6914!important; background:#fffdf7!important; }',
    'fieldset[data-option-name="size"][data-cf-enhanced] input:checked + label.cf-label-enhanced, fieldset[data-option-name="size"][data-cf-enhanced] label.cf-label-enhanced:has(+ input:checked), fieldset[data-option-name="size"][data-cf-enhanced] label.cf-label-enhanced.active, fieldset[data-option-name="size"][data-cf-enhanced] label.cf-label-enhanced[aria-checked="true"] { border-color:#8b6914!important; background:#f9f5ec!important; box-shadow:0 0 0 1px #8b6914!important; }',

    '/* ========== LABEL NAME, DIM, DESC ========== */',
    '.cf-label-name { font-size:14px!important; font-weight:700!important; color:#333!important; display:block!important; line-height:1.2; }',
    '.cf-label-dim { font-size:12px!important; font-weight:500!important; color:#8b6914!important; display:block!important; margin-top:1px; }',
    '.cf-label-desc { font-size:11px; color:#999; margin-top:2px; line-height:1.3; font-weight:400!important; display:block!important; }',
    '.cf-badge-popular { position:absolute; top:-8px; right:10px; background:#8b6914; color:#fff; font-size:9px; font-weight:700; padding:2px 8px; border-radius:4px; letter-spacing:.3px; z-index:1; }',

    '/* ========== EXTRAS ROW ========== */',
    '.cf-extras-inline { display:flex; align-items:center; gap:10px; margin-top:12px; padding-top:12px; border-top:1px solid #eee; width:100%; flex-basis:100%; }',
    '.cf-extras-inline .cf-extras-label { font-size:12px; color:#999; white-space:nowrap; }',
    '.cf-extras-inline label { min-width:auto!important; max-width:fit-content!important; width:auto!important; flex:0 0 auto!important; min-height:auto!important; height:auto!important; padding:8px 16px!important; margin:0!important; flex-direction:row!important; align-items:center!important; gap:6px!important; border:1.5px solid #e0dbd4!important; border-radius:10px!important; background:#fff!important; cursor:pointer!important; font-size:13px!important; color:#333!important; transition:border-color .15s!important; }',
    '.cf-extras-inline label:hover { border-color:#8b6914!important; }',
    '.cf-extras-inline input:checked + label { border-color:#8b6914!important; background:#f9f5ec!important; box-shadow:0 0 0 1px #8b6914!important; }',

    '/* ========== REASSURANCE ========== */',
    '.cf-reassurance { margin-top:14px; padding:14px 18px; background:#f8f6f3; border-radius:10px; font-size:13px; line-height:1.6; color:#555; width:100%; }',
    '.cf-reassurance strong { color:#333; }',
    '.cf-reassurance a { color:#8b6914; text-decoration:underline; }',

    '/* ========== FORCE HIDE ========== */',
    'fieldset[data-option-name="size"][data-cf-enhanced] .cf-hidden { display:none!important; visibility:hidden!important; width:0!important; height:0!important; margin:0!important; padding:0!important; overflow:hidden!important; position:absolute!important; }',

    '/* ========== RESPONSIVE ========== */',
    '@media (max-width:999px) { .cf-part-tabs{gap:6px} .cf-part-tab{padding:6px 3px} .cf-part-tab .cf-tab-icon svg{width:36px;height:28px} .cf-part-tab .cf-tab-label{font-size:13px} fieldset[data-option-name="size"][data-cf-enhanced] label.cf-label-enhanced{padding:8px 10px!important;min-height:48px!important} }',
    '@media (max-width:599px) { .cf-part-tabs{grid-template-columns:repeat(4,1fr);gap:5px} .cf-part-tab{padding:5px 2px;gap:2px} .cf-part-tab .cf-tab-icon svg{width:32px;height:26px} .cf-part-tab .cf-tab-label{font-size:12px} .cf-tab-badge{font-size:7px;padding:1px 4px} fieldset[data-option-name="size"][data-cf-enhanced]{gap:6px!important;column-gap:6px!important;row-gap:6px!important} fieldset[data-option-name="size"][data-cf-enhanced] label.cf-label-enhanced{flex:1 1 calc(50% - 4px)!important;max-width:none!important;padding:8px 10px!important;min-height:auto!important} .cf-depth-btn{padding:6px 12px;font-size:12px} .cf-label-name{font-size:13px!important} .cf-label-dim{font-size:11px!important} .cf-label-desc{font-size:10px;line-height:1.2} }',
  ].join('\n');
  document.head.appendChild(styles);

  function buildTabIcon(cfg) {
    var wrap = document.createElement('div');
    wrap.className = 'cf-tab-icon';
    // Parse SVG via text/html to avoid XML namespace issues in HTML documents
    var parser = new DOMParser();
    var doc = parser.parseFromString(cfg.icon, 'text/html');
    var svg = doc.querySelector('svg');
    if (svg) wrap.appendChild(document.adoptNode(svg));
    return wrap;
  }

  function enhanceSizeSelector() {
    var sf = document.querySelector('fieldset[data-option-name="size"]');
    if (!sf || sf.dataset.cfEnhanced) return;
    sf.dataset.cfEnhanced = 'true';

    // Remove old reassurance/extras if re-enhancing
    document.querySelectorAll('.cf-reassurance, .cf-extras-inline, .cf-depth-toggle').forEach(function(e) { e.remove(); });

    // Collect all radio inputs + labels
    var radios = Array.from(sf.querySelectorAll('input[type="radio"]'));
    var checked = sf.querySelector('input:checked');
    var checkedVal = checked ? checked.value : '';

    // Group radios by part
    var groups = { armrest: [], backrest: [], seat: [], bundle: [], extras: [], hidden: [], unknown: [] };
    radios.forEach(function(radio) {
      var label = sf.querySelector('label[for="' + radio.id + '"]');
      if (!label) return;
      var config = lookupVariant(radio.value);
      var part = config ? config.part : 'unknown';
      if (!groups[part]) part = 'unknown';
      groups[part].push({ radio: radio, label: label, config: config, value: radio.value });
    });

    // Detect default tab from current selection
    if (!activeTab) {
      var checkedConfig = lookupVariant(checkedVal);
      activeTab = (checkedConfig && checkedConfig.part && checkedConfig.part !== 'extras') ? checkedConfig.part : 'seat';
    }

    // --- Build tabs (insert BEFORE the labels) ---
    var tabs = document.createElement('div');
    tabs.className = 'cf-part-tabs';
    MAIN_PARTS.forEach(function(k) {
      var cfg = TAB_CONFIG[k];
      var t = document.createElement('div');
      t.className = 'cf-part-tab' + (k === activeTab ? ' active' : '');

      t.appendChild(buildTabIcon(cfg));

      var lbl = document.createElement('div');
      lbl.className = 'cf-tab-label';
      lbl.textContent = cfg.label;
      t.appendChild(lbl);

      if (cfg.badge) {
        var badge = document.createElement('span');
        badge.className = 'cf-tab-badge';
        badge.textContent = cfg.badge;
        t.appendChild(badge);
      }

      t.addEventListener('click', function() {
        activeTab = k;
        tabs.querySelectorAll('.cf-part-tab').forEach(function(x) { x.classList.remove('active'); });
        t.classList.add('active');
        showGroup(k);
      });
      tabs.appendChild(t);
    });
    // Insert tabs after the legend
    var legend = sf.querySelector('legend');
    if (legend) legend.after(tabs);
    else sf.prepend(tabs);

    // --- Depth toggle (for seat only) ---
    var depthToggle = document.createElement('div');
    depthToggle.className = 'cf-depth-toggle';
    depthToggle.style.display = 'none';

    var btnStd = document.createElement('button');
    btnStd.className = 'cf-depth-btn' + (activeDepth === 'standard' ? ' active' : '');
    btnStd.dataset.depth = 'standard';
    btnStd.textContent = 'Standard (\u226435")';
    depthToggle.appendChild(btnStd);

    var btnDeep = document.createElement('button');
    btnDeep.className = 'cf-depth-btn' + (activeDepth === 'deep' ? ' active' : '');
    btnDeep.dataset.depth = 'deep';
    btnDeep.textContent = 'Deep seat (36"+)';
    depthToggle.appendChild(btnDeep);

    depthToggle.querySelectorAll('.cf-depth-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        activeDepth = btn.dataset.depth;
        depthToggle.querySelectorAll('.cf-depth-btn').forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');
        showGroup('seat');
      });
    });
    tabs.after(depthToggle);
    // Line break after depth toggle so cards start on new row
    var depthBreak = document.createElement('div');
    depthBreak.style.cssText = 'flex:0 0 100%!important;width:100%!important;height:0;';
    depthToggle.after(depthBreak);

    // --- Enhance each label: rename + description + badge ---
    Object.values(groups).flat().forEach(function(item) {
      var label = item.label, config = item.config, value = item.value;
      if (!config || !config.label) return;
      if (label.querySelector('.cf-label-name')) return; // Already enhanced

      label.classList.add('cf-label-enhanced');
      label.style.setProperty('flex-direction', 'column', 'important');
      label.style.setProperty('align-items', 'flex-start', 'important');

      // Hide ALL original child elements
      Array.from(label.children).forEach(function(child) {
        if (!child.classList.contains('cf-label-name') &&
            !child.classList.contains('cf-label-dim') &&
            !child.classList.contains('cf-label-desc') &&
            !child.classList.contains('cf-badge-popular')) {
          child.style.setProperty('display', 'none', 'important');
        }
      });

      var name = document.createElement('span');
      name.className = 'cf-label-name';
      name.textContent = config.label;
      label.insertBefore(name, label.firstChild);

      var dim = document.createElement('span');
      dim.className = 'cf-label-dim';
      dim.textContent = value.replace(' (1pc)', '').replace('Backrest ', '');
      label.insertBefore(dim, name.nextSibling);

      if (config.desc) {
        var desc = document.createElement('span');
        desc.className = 'cf-label-desc';
        desc.textContent = config.desc;
        label.appendChild(desc);
      }

      if (config.popular) {
        label.style.position = 'relative';
        var popBadge = document.createElement('span');
        popBadge.className = 'cf-badge-popular';
        popBadge.textContent = 'POPULAR';
        label.appendChild(popBadge);
      }
    });

    // --- Hide extras (pillow) — not part of size selection ---
    (groups.extras || []).forEach(function(item) { cfHide(item.radio); cfHide(item.label); });
    (groups.hidden || []).forEach(function(item) { cfHide(item.radio); cfHide(item.label); });

    // --- Show/hide function ---
    var tabNote = document.createElement('div');
    tabNote.style.cssText = 'flex:0 0 100%!important;width:100%!important;font-size:12px;color:#999;margin-bottom:6px;';
    depthBreak.after(tabNote);

    function showGroup(part) {
      depthToggle.style.display = part === 'seat' ? 'flex' : 'none';

      if (part === 'bundle') {
        tabNote.textContent = 'Standard depth sets (seat width \u226435"). For deep sofas (36"+), buy individual pieces in Seat & Chaise tab.';
        tabNote.style.display = '';
      } else if (part === 'backrest') {
        tabNote.textContent = 'Sold individually (1pc per order). Buy 1 piece per seat on your sofa.';
        tabNote.style.display = '';
      } else if (part === 'armrest') {
        tabNote.textContent = 'Sold individually (1pc per order). Most sofas need 2 pieces (left + right).';
        tabNote.style.display = '';
      } else {
        tabNote.style.display = 'none';
      }

      MAIN_PARTS.forEach(function(k) {
        groups[k].forEach(function(item) {
          var show = (k === part);
          if (k === 'seat' && show && item.config && item.config.depth) {
            show = item.config.depth === activeDepth;
          }
          if (show) { cfShow(item.label, true); cfShow(item.radio, false); }
          else      { cfHide(item.label);        cfHide(item.radio);        }
        });
      });

      groups.unknown.forEach(function(item) { cfHide(item.label); cfHide(item.radio); });
    }

    showGroup(activeTab);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhanceSizeSelector);
  else enhanceSizeSelector();

  // ── MANUAL VARIANT UPDATE (v8+v11) ─────────────────────────────────
  // V11: uses cfFormatPrice() instead of hardcoded '$'.
  var variantCache = null;

  async function loadVariants() {
    if (variantCache) return variantCache;
    try {
      var handle = location.pathname.split('/products/')[1];
      if (handle) handle = handle.split('?')[0];
      if (!handle) return null;
      var resp = await fetch('/products/' + handle + '.json');
      var data = await resp.json();
      variantCache = data.product.variants;
      return variantCache;
    } catch (e) { return null; }
  }
  loadVariants(); // preload

  async function applyVariant(sizeValue) {
    var variants = await loadVariants();
    if (!variants) return;

    var colorFs = document.querySelector('fieldset[data-option-name="color"]');
    var currentColor = colorFs ? (colorFs.querySelector('input:checked') || {}).value || '' : '';
    var sizeNorm = norm(sizeValue);

    var match = variants.find(function(v) {
      var parts = v.title.split(' / ');
      var vColor = parts[0] || '';
      var vSize = norm(parts.slice(1).join(' / '));
      return vSize === sizeNorm && (!currentColor || norm(vColor) === norm(currentColor));
    });
    if (!match) return;

    var price = parseFloat(match.price);
    var compareAt = match.compare_at_price ? parseFloat(match.compare_at_price) : null;
    // V11: currency-aware formatting (was hardcoded '$' in V10)
    var priceStr = cfFormatPrice(price);
    var compareStr = compareAt ? cfFormatPrice(compareAt) : '';
    var priceCents = Math.round(price * 100).toString();
    var compareCents = compareAt ? Math.round(compareAt * 100).toString() : '0';

    // Hidden form input
    document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(function(el) {
      el.value = match.id;
    });

    // URL
    var url = new URL(location.href);
    url.searchParams.set('variant', match.id);
    history.replaceState({}, '', url.toString());

    // Update all .main-product-price containers (theme structure)
    document.querySelectorAll('.main-product-price').forEach(function(el) {
      var targetPrice = el.querySelector('.target-price');
      var targetCompare = el.querySelector('.target-compare-at-price');
      var saleSpan = el.querySelector('.price-sale');
      var compareEl = el.querySelector('s.price-compare');
      var pSpan = el.querySelector('p.price span');

      if (targetPrice) targetPrice.textContent = priceCents;
      if (targetCompare) targetCompare.textContent = compareCents;
      if (saleSpan) saleSpan.textContent = priceStr;
      if (pSpan) pSpan.textContent = priceStr;
      if (compareEl) {
        if (compareAt && compareAt > price) {
          compareEl.textContent = compareStr;
          var small = compareEl.closest('small');
          if (small) small.style.removeProperty('display');
        } else {
          compareEl.textContent = '';
          var small2 = compareEl.closest('small');
          if (small2) small2.style.setProperty('display', 'none');
        }
      }
    });
  }

  // Intercept size label clicks — prevent native Shopify behavior, do manual update
  document.addEventListener('click', function(e) {
    var label = e.target.closest('fieldset[data-option-name="size"][data-cf-enhanced] label');
    if (!label) return;

    var radioId = label.getAttribute('for');
    var radio = radioId ? document.getElementById(radioId) : null;
    if (!radio) return;

    e.preventDefault();
    e.stopPropagation();
    radio.checked = true;
    applyVariant(radio.value);
  }, true);

  // MutationObserver — only needed for color changes (which still trigger re-render)
  new MutationObserver(function() {
    var sf = document.querySelector('fieldset[data-option-name="size"]:not([data-cf-enhanced])');
    if (sf) enhanceSizeSelector();
  }).observe(document.body, { childList: true, subtree: true });
})();
